/* SAEGE - a colon after each variant option name.
 *
 * "Ring Size:", "Birthstone:", "Letter:" - matching the "Colour:" swatch
 * label, which gets its colon in Liquid (sections/main-product.liquid). Same
 * punctuation on every option name in the buy column.
 *
 * WHY THIS IS JS AND NOT ONE LINE OF CSS. The obvious version is
 * legend.label::after { content: ":" }. It produces "Birthstone :" on the
 * birthstone products, because the option is named "Birthstone " in Shopify -
 * with a trailing space - and a trailing space followed by an inline ::after
 * box is NOT collapsed away: it is only dropped at the end of a line, and here
 * the colon follows it. CSS cannot trim a text node. So the text is trimmed
 * and the colon appended in one step, which also fixes the stray space.
 *
 * Left alone on purpose: the option name in Shopify. Renaming it would clean
 * this up at source, but option names are product data shared with the LIVE
 * theme, and this is a preview-theme change.
 *
 * Idempotent - a name that already ends in a colon is left as it is, so a
 * re-run (or a later fix to the product data) cannot produce "Birthstone::".
 *
 * Turn off: option_label_colon in snippets/saege-pdp-loader.liquid
 */
(function () {
  'use strict';

  var started = false;

  function apply() {
    var legends = [].slice.call(
      document.querySelectorAll('.saege-ordered .option-selector legend.label')
    );
    if (!legends.length) return false;

    legends.forEach(function (l) {
      var text = (l.textContent || '').trim();
      if (!text || text.slice(-1) === ':') return;
      l.textContent = text + ':';
    });
    return true;
  }

  function start() {
    if (started) return;
    if (apply()) started = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* .saege-ordered is tagged by assets/saege-pdp.js on its own retry loop, so
     the options can exist before the scope class does */
  var tries = 0;
  var iv = setInterval(function () {
    if (started || ++tries > 20) { clearInterval(iv); return; }
    start();
  }, 150);
})();
